<template>
  <v-snackbar
    :key="snackbarState.id"
    v-model="snackbarState.show"
    :color="snackbarState.color"
    :timeout="snackbarState.timeout"
    :theme="snackbarState.dark ? 'dark' : snackbarState.light ? 'light' : undefined"
    @click="onClick"
  >
    <span>{{ snackbarState.text }}</span>
    <template
      v-if="snackbarState.action"
      #actions
    >
      <v-btn
        variant="text"
        data-testid="snackbar-action"
        @click.stop="onAction(snackbarState.action)"
      >
        {{ snackbarState.action.label }}
      </v-btn>
    </template>
    <template
      v-if="snackbarState.timeout < 0"
      #activator="{ props }"
    >
      <v-btn
        variant="text"
        v-bind="props"
        @click="snackbarState.show = false"
      >
        Schließen
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script setup lang="ts">
import type { SnackbarAction } from "~/composables/snackbar"

const onAction = (action: SnackbarAction) => {
  snackbarState.value.show = false
  action.onClick()
}

const onClick = () => {
  // close on click, but not when selecting text
  const cellText = document.getSelection()
  if (cellText?.type !== "Range") snackbarState.value.show = false
}
</script>
